import React from 'react';
import Well from '$components/ProductDashboard/Well';
import styles from '../../textStyles.scss';

const Content = () => (
  <Well>
    <div className={styles.layout}>
      <h2 className={styles.header}>
        Achievable includes <b>5+ full-length Series 63 practice exams</b>
      </h2>

      <p>
        Achievable&apos;s Series 63 practice exams are a good estimate of your actual exam
        score. Our exams are generated with similar topic weightings and phrasing that you
        can expect on the actual exam.
      </p>

      <p>
        Achievable uses dynamic question templates to create multiple unique versions of a
        question. We intelligently randomize the question prompt, answer, distractors, and
        explanation. A single question template can have hundreds of variations, ensuring
        that you thoroughly understand the concept and aren&apos;t just remembering an
        answer you&apos;ve seen previously.
      </p>

      <p>
        <i>
          When you sit for the actual exam, it will include an additional 5 experimental
          questions that are not scored, but must be completed within the same time limit.
        </i>
      </p>
    </div>
  </Well>
);

export default Content;
